import { Epic, ofType } from 'redux-observable';
import { EMPTY, from, Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { Action } from '../../actions';
import {
    SaveImportExportWizardSuccess,
    saveImportExportWizardSuccessAction
} from '../../actions/importExportWizard/saveImportExportWizardSuccess';
import {
    UpdateImportWizardStep,
    updateImportWizardStepAction
} from '../../actions/importWizard/updateImportWizardStep';
import {
    UPLOAD_IMAGES_IMPORT_WIZARD,
    UploadImagesImportWizard
} from '../../actions/importWizard/uploadImagesImportWizard';
import { ApiMethodExecutingError } from '../../service/Errors';
import { EpicDeps } from '../../service/StoreFactory';
import { ImportWizardPhase } from '../../typings/importWizard';
import { State } from '../../typings/state';

type EpicActions = SaveImportExportWizardSuccess | UpdateImportWizardStep;

export const uploadImagesImportWizardEpic: Epic<Action, Action, State, EpicDeps> = (action$, store, deps) => {
    return action$.pipe(
        ofType(UPLOAD_IMAGES_IMPORT_WIZARD),
        switchMap(
            (action: UploadImagesImportWizard): Observable<EpicActions> => {
                return from(deps.importProvider.uploadImages()).pipe(
                    switchMap(
                        (): Observable<EpicActions> =>
                            of(
                                updateImportWizardStepAction(ImportWizardPhase.VALIDATION),
                                saveImportExportWizardSuccessAction()
                            )
                    ),
                    catchError((error: ApiMethodExecutingError): typeof EMPTY => EMPTY)
                );
            }
        )
    );
};
